import {
  Button,
  Card,
  Text,
} from '@/components/DesignSystem';
import React, { useState } from 'react';
import { Stack, useTheme } from "@mui/material";
import { isEmpty } from "lodash";
import AddIcon from "@mui/icons-material/Add";
import { useQuery, useQueryClient } from "react-query";
import { QueryKeys } from "@/constants/QueryKeys";
import { TwilioConfigApi } from "@/utilities/api/TwilioConfigApi";
import { SaveTwilioDetailsModal }
  from "@/pages/Admin/HierarchyOfRetailers/Twilio/SaveTwilioDetailsModal";

interface TwilioDetailsProps {
  retailerId: string,
}

export const TwilioDetails = ({
  retailerId,
}: TwilioDetailsProps) => {
  const theme = useTheme();
  const [showTwilioConfigModal, setShowTwilioConfigModal] = useState(false);
  const queryClient = useQueryClient();

  const { data: existingTwilioConfig } = useQuery(
    [QueryKeys.GET_RETAILER_TWILIO_CONFIG, retailerId],
    async () => TwilioConfigApi.getByRetailerId(retailerId),
  );
  const isConnected = !isEmpty(existingTwilioConfig);

  return (
    <Card elevation={0} testID="twilio-details-card">
      <Stack alignItems="center" direction="row" justifyContent="space-between" spacing={2}>
        <Stack>
          <Text category="title-small">Twilio Details</Text>
          <Text category="body-medium" sx={{ color: theme.palette.text.secondary }}>
            Connection for outgoing SMS notifications
          </Text>
        </Stack>
        <Button
          onClick={() => setShowTwilioConfigModal(true)}
          size="small"
          startIcon={isConnected ? null : <AddIcon />}
          testID="show-integration-details-button"
        >
          {isConnected ? 'View' : 'Add'}
        </Button>
      </Stack>
      {showTwilioConfigModal && (
        <SaveTwilioDetailsModal
          existingTwilioConfig={isConnected ? existingTwilioConfig : null}
          onClose={() => setShowTwilioConfigModal(false)}
          onSave={() => queryClient.invalidateQueries(QueryKeys.GET_RETAILER_TWILIO_CONFIG)}
          retailerId={retailerId}
        />
      )}
    </Card>
  );
};
